import { Injectable } from "@angular/core";
import { Observable, Observer } from 'rxjs';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "environments/environment";

import { RxStomp, RxStompConfig } from '@stomp/rx-stomp';


@Injectable({
    providedIn: 'root'
})
export class RxStompService extends RxStomp {

    constructor() {
        super();
      }

}